import request from '../utils/request';
import type { 
  WarehouseListParams, 
  WarehouseListResponse, 
  WarehouseDetail 
} from '../types/warehouse';
import { DataValidator } from '../utils/dataValidation';
import { ErrorHandler } from '../utils/errorHandler';

export function getWarehouseList(params: WarehouseListParams) {
  return request.get<WarehouseListResponse>('/api/v1/warehouses/', { params });
}

export function getWarehouseDetail(id: number) {
  return request.get<WarehouseDetail>(`/api/v1/warehouses/${id}/`);
}

export function createWarehouse(data: Partial<WarehouseDetail>) {
  return request.post<WarehouseDetail>('/api/v1/warehouses/', data);
}

export function updateWarehouse(id: number, data: Partial<WarehouseDetail>) {
  return request.put<WarehouseDetail>(`/api/v1/warehouses/${id}/`, data);
}

export function deleteWarehouse(id: number) {
  return request.delete<void>(`/api/v1/warehouses/${id}/`);
}

// 获取所有仓库（不分页，用于入库记录过滤）
export const getAllWarehouses = async (): Promise<WarehouseDetail[]> => {
  try {
    const response = await request.get('/api/v1/warehouses/', {
      params: { 
        page_size: 1000 // 设置一个足够大的值来获取所有仓库
      }
    });
    
    // 使用统一的数据验证工具
    const validatedData = DataValidator.validatePaginatedResponse<WarehouseDetail>(response.data);
    
    // 仓库数据获取完成
    return validatedData.results;
  } catch (error) {
    ErrorHandler.handleApiError(error, '获取仓库数据');
    throw error;
  }
}; 